import gql from "graphql-tag"

export const preCheckoutMutationGQL = gql`
    mutation preCheckoutMutation($cartItemIds: [String]) {
        preCheckout(cartItemIds: $cartItemIds)    
    }
`

export const doCheckoutMutationGQL = gql`
    mutation doCheckoutMutation($cartItemIds:[String]) {
        doCheckout(cartItemIds: $cartItemIds)
    }
`